<template>
  <SimpleDialog
    v-model="show"
    v-bind="$attrs"
    max-width="442"
    center_title
    bts_align="center"
    @close="cancel"
    @keydown.esc="cancel"
  >
    <template #title>
      {{ title }}
    </template>

    <template
      #text
    >
      <div
        v-if="message"
        class="text-center"
        :class="$style.text"
      >
        {{ message }}
      </div>

    </template>

    <template #actions>
      <v-btn
        depressed
        color="accent darken-4"
        :loading="loading"
        @click="agree"
      >
        <slot name="agree">
          Применить
        </slot>
      </v-btn>
      <v-btn
        depressed
        text
        @click="cancel"
      >
        <slot name="cancel">
          Отменить
        </slot>
      </v-btn>
    </template>
  </SimpleDialog>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import SimpleDialog from '../simple/SimpleDialog.vue';

@Component({
  components: {
    SimpleDialog,
  },
})
export default class ConfirmDialog extends Vue {
  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  dialog = false;

  resolve: (value: boolean) => void = () => ({});

  reject: (value: boolean) => void = () => ({});

  message = '';

  title = '';

  get show() {
    return this.dialog;
  }

  set show(value) {
    this.dialog = value;

    if (value === false) {
      this.cancel();
    }
  }

  open(title: string, message?: string) {
    this.dialog = true;
    this.title = title;
    this.message = message || '';

    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  hide() {
    this.cancel();
  }

  agree() {
    this.resolve(true);
    this.dialog = false;
  }

  cancel() {
    this.resolve(false);
    this.dialog = false;
  }
}
</script>

<style module lang="scss">
.text {
  color: $primary_darken1 !important;
}
</style>
